/* eslint-disable jsx-a11y/no-onchange */
import React, { FC, ReactElement } from 'react';
import { withRouter } from 'react-router-dom';
import { localizeType } from '../../commonType';
import withLocalization from '../hoc/withLocalization';

interface GuestInformationprops {
  localize: localizeType;
  maxGuests: number;
  onGuestSelectionChange: (n: number, m: number) => void;
  adultNum: number;
  childNum: number;
}

const GuestInformation: FC<GuestInformationprops> = (props: GuestInformationprops): ReactElement => {
  const { localize, maxGuests, onGuestSelectionChange, childNum, adultNum } = props;
  const adultsArray = () => {
    const items: JSX.Element[] = [];
    for (let i = 1; i <= maxGuests; i++) {
      items.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }
    return items;
  };
  const childArray = () => {
    const items: JSX.Element[] = [];
    for (let i = 0; i <= maxGuests - 1; i++) {
      items.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }
    return items;
  };

  const handleChild = (e) => {
    let value = parseInt(e.target.value);
    onGuestSelectionChange(adultNum, value);
  };
  const handleAdult = (e) => {
    let value = parseInt(e.target.value);
    onGuestSelectionChange(value, childNum);
  };

  return (
    <>
      <div className="form-row">
        <div className="form-group col-md-6">
          <label htmlFor="numberOfAdults">
            {localize('preview-sales-engine.static-content.copy.contact-information-page.adults')}
            <select id="numberOfAdults" className="form-control" onChange={handleAdult} defaultValue={adultNum}>
              {adultsArray()}
            </select>
          </label>
        </div>
        <div className="form-group col-md-6">
          <label htmlFor="numberofChildren">
            {localize('preview-sales-engine.static-content.copy.contact-information-page.children')}
            <select id="numberofChildren" className="form-control" onChange={handleChild} defaultValue={childNum}>
              {childArray()}
            </select>
          </label>
        </div>
      </div>
    </>
  );
};

export default withRouter(withLocalization(GuestInformation));
